import styled from '@emotion/styled';
import { SkeletonPlaceholder } from '@modernhealth/vital-components';
import { breakpointValues } from '@modernhealth/vital-foundation';

import { mediaQueryMinWidth } from 'src/shared/utils';

const PageWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 100,
  [mediaQueryMinWidth(breakpointValues.md)]: {
    paddingRight: '25%',
    paddingLeft: '25%',
  },
});

const TopicPageSkeleton: React.FC = () => {
  return (
    <PageWrapper>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: 50,
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginRight: 30,
            width: '60%',
          }}
        >
          <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={10} />
          <SkeletonPlaceholder width="60%" height={25} borderRadius={4} marginBottom={25} />
        </div>
        <SkeletonPlaceholder width={100} height={100} borderRadius={100} />
      </div>
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={25} borderRadius={4} marginBottom={20} />
      <div style={{ display: 'flex', alignSelf: 'flex-start' }}>
        <SkeletonPlaceholder
          width={100}
          height={25}
          borderRadius={4}
          marginBottom={10}
          marginTop={30}
        />
      </div>

      <SkeletonPlaceholder width="100%" height={40} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={40} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width="100%" height={40} borderRadius={4} marginBottom={20} />
    </PageWrapper>
  );
};

export default TopicPageSkeleton;
